/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import useOpen from '@/hooks/useOpen';
import { Popover } from '@ui5/webcomponents-react';
import React, { PropsWithChildren, useId } from 'react';

type Props = PropsWithChildren<{
    content: React.ReactNode;
}>;

export default function Tooltip(props: Props) {
    const { children, content } = props;
    const [open, toggle] = useOpen();
    const id = useId();

    if (!React.isValidElement(children)) {
        throw new Error('Tooltip children must be a valid React element');
    }

    const enhancedChild = React.cloneElement(children as React.ReactElement, {
        id,
        onMouseOut: toggle,
        onMouseEnter: toggle,
    });

    return (
        <>
            {enhancedChild}
            <Popover open={open} opener={id}>
                {content}
            </Popover>
        </>
    );
}
